/**
 * @desc 开发环境配置
 * @auther tianke
 */
let dev = {
  version: '1.0.0',
  env: 'dev',
  api: {
    domain: 'http://sit.eco.lingzhuyun.com:7080',
    // host: 'http://dev.eco.lingzhuyun.com:30101' // 接口地址
    host: 'http://sit.eco.lingzhuyun.com:30101' // 接口地址
    // host: 'http://uat.eco.lingzhuyun.com:30101' // 接口地址
    // host: 'http://eco.lingzhuyun.com:30101'
  }
}

export default dev



// WEBPACK FOOTER //
// ./src/config/dev.js